<template>
  <!--标题组-->
  <div class="title-group">
    <h2 class="title">{{ title }}</h2>
    <span class="link"
      v-if="url"
      @click="toggleUrl">查看全部<i class="icon icon-more"></i></span>
  </div>
</template>

<script>
export default {
  name: 'TitleGroup',
  props: ['title', 'url'],
  methods: {
    toggleUrl () {
      this.$router.push({
        path: this.url
      })
    }
  }
}
</script>

<style lang="less" scoped>
@image: "../../assets/images/";

.title-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30/200rem;
  overflow: hidden;

  .title {
    font-size: 44/200rem;
    font-weight: 600;
    color: rgba(46, 46, 46, 1);
  }
  .link {
    position: relative;
    font-size: 28/200rem;
    font-weight: 500;
    color: rgba(153, 153, 153, 1);
    padding-right: 30/200rem;

    .icon-more {
      position: absolute;
      right: 0;
      top: 50%;
      width: 10/200rem;
      height: 20/200rem;
      margin-top: -10/200rem;
      background-image: url("@{image}icon-right.png");
      background-size: 100% 100%;
    }
  }
}
</style>
